import { STEPS } from "@/constants/testIds";

const STEPS_LIST = [
  {
    n: "01",
    title: "Choose your package",
    desc: "Select the ideal option for your space, theme and guest list. We'll confirm availability within hours.",
  },
  {
    n: "02",
    title: "We set it up",
    desc: "We deliver, build and fully sanitize everything before your first little guest arrives.",
  },
  {
    n: "03",
    title: "You enjoy",
    desc: "Soak up the party. We pack up and clean after the event — zero effort on your end.",
  },
];

const IMG =
  "/images/ballpit-boy.jpg";

export default function Steps() {
  return (
    <section
      id="how"
      data-testid={STEPS.section}
      className="relative py-24 md:py-32 bg-brand-base overflow-hidden"
    >
      {/* soft color field for the glass to refract */}
      <div aria-hidden className="pointer-events-none absolute inset-0">
        <div className="absolute top-16 right-[8%] w-[380px] h-[380px] rounded-full bg-brand-blush/45 blur-3xl" />
        <div className="absolute bottom-10 right-[38%] w-[340px] h-[340px] rounded-full bg-brand-sage/45 blur-3xl" />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5 lg:sticky lg:top-32">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-brand-terracotta mb-5">
            How it works
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight text-brand-ink">
            Three simple steps,
            <br />
            <span className="italic text-brand-terracotta">zero hassle.</span>
          </h2>
          <p className="mt-6 text-lg text-brand-mute font-light max-w-md">
            We handle every detail so you can focus on the people you love.
          </p>

          <div className="mt-10 relative hidden lg:block">
            <div className="absolute -top-6 -left-6 w-24 h-24 rounded-full bg-brand-blush/80 -z-10" />
            <div className="absolute -bottom-6 -right-6 w-28 h-28 rounded-full bg-brand-sage/70 -z-10 animate-float-soft" />
            <img
              src={IMG}
              alt="Child playing in a soft, safe ball pit environment"
              className="w-full rounded-[2rem] object-cover h-[400px] border border-[#E9DED1] shadow-xl shadow-[#B8A792]/20"
            />
          </div>
        </div>

        <ol className="lg:col-span-7 space-y-6">
          {STEPS_LIST.map((s) => (
            <li
              key={s.n}
              data-testid={STEPS.step(s.n)}
              className="group relative grid grid-cols-[auto_1fr] gap-7 glass-card rounded-3xl p-8 md:p-10 transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
            >
              <div className="flex items-start">
                <span className="font-serif text-5xl md:text-6xl text-brand-terracotta leading-none">
                  {s.n}
                </span>
              </div>
              <div>
                <h3 className="font-serif text-2xl md:text-3xl text-brand-ink leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-base text-brand-mute font-light leading-relaxed">
                  {s.desc}
                </p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
